import React, { Component, ReactNode } from 'react';
import styles from './SectionItem.module.scss';

interface ISectionItemProps {
	children: ReactNode;
	title?: string;
	icon?: string;
	iconLink?: string;
}

export default class SectionItem extends Component<ISectionItemProps> {
	icon = () => {
		const { icon, iconLink } = this.props;

		return iconLink ? (
			<a href={iconLink} target="_blank">
				<img src={icon} className={styles.icon} />
			</a>
		) : (
			<img src={icon} className={styles.icon} />
		);
	};

	render() {
		const { icon, title, iconLink } = this.props;

		return (
			<div className={styles.sectionItem}>
				<div className={styles.iconContainer}>{icon || iconLink ? this.icon() : null}</div>
				<div className={styles.content}>
					<div className={styles.title}>{title}</div>
					<div className={styles.text}>{this.props.children}</div>
				</div>
			</div>
		);
	}
}
